import * as TileImageLoader from "../tileImageLoader";

/** Cache for DOM icons, keyed by filename@size. Dedupes in-flight loads so concurrent callers share the Promise. */
export class IconLoader {
	private static cache = new Map<string, HTMLCanvasElement>();
	private static pending = new Map<string, Promise<HTMLCanvasElement>>();

	private static buildKey(filename: string, size: number): string {
		return `${filename}@${size}`;
	}

	static loadIcon(filename: string, size: number): Promise<HTMLCanvasElement> {
		const key = this.buildKey(filename, size);

		const cached = this.cache.get(key);
		if (cached) return Promise.resolve(cached);

		const inFlight = this.pending.get(key);
		if (inFlight) return inFlight;

		const promise = TileImageLoader.getImage(filename, size, size).then((canvas) => {
			this.cache.set(key, canvas);
			this.pending.delete(key);
			return canvas;
		});
		this.pending.set(key, promise);
		return promise;
	}

	/** Does not trigger a load. */
	static getCachedIcon(filename: string, size: number): HTMLCanvasElement | null {
		return this.cache.get(this.buildKey(filename, size)) ?? null;
	}

	/** cloneNode doesn't copy canvas pixels, and a canvas can only have one DOM parent. */
	static copyIconCanvas(source: HTMLCanvasElement): HTMLCanvasElement {
		const copy = document.createElement("canvas");
		copy.width = source.width;
		copy.height = source.height;
		copy.getContext("2d")!.drawImage(source, 0, 0);
		return copy;
	}
}
